import { AbstractSettings, AbstractSettingsDef } from "./AbstractSettings";
import { SettingsRegistry } from "./SettingsRegistry";

export interface LicenseSettingsDef extends AbstractSettingsDef {
    licensed_packages: string[];
    licensed_classes: string[];
    excluded_classes: string[];
    temp_revoked_modules: string[];
}

export class LicenseSettings extends AbstractSettings {
    constructor() {
        super("license_settings");
    }

    public static getSingleton(): LicenseSettings {
        return SettingsRegistry.get().getObject("license_settings") as LicenseSettings;
    }

    public static get(): LicenseSettingsDef {
        return LicenseSettings.getSingleton().values as LicenseSettingsDef;
    }

    public override get values(): LicenseSettingsDef {
        return super.values as LicenseSettingsDef;
    }

    protected getValuesInternal(): LicenseSettingsDef {
        return this._values as LicenseSettingsDef;
    }

    public get licensedPackages(): string[] {
        return [ ...this.getValuesInternal()?.licensed_packages ];
    }

    public get licensedClasses(): string[] {
        return [ ...this.getValuesInternal()?.licensed_classes ];
    }

    public get excludedClasses(): string[] {
        return [ ...this.getValuesInternal()?.excluded_classes ];
    }

    public getTempRevokedModules(): string[] {
        const revokedModules = this.getValuesInternal()?.temp_revoked_modules;
        return revokedModules != null ? [ ...revokedModules ] : [];
    }
}
